import Vue from "vue";
import Vuex from "vuex";
import school from "./modules/school";
import student from "./modules/student";
import mentor from "./modules/mentor";
import platoon from "./modules/platoon";
import user from "./modules/user";
import team from "./modules/team";
import axios from "axios";
import cookie from "vue-cookie";
// import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    summery: {
      school: 0,
      student: 0,
      platoon: 0,
      adviser: 0,
      title: "کل کشور",
    },
    menuType: "menu-default sub-hidden",
    menuTypeLarge: "menu-default sub-hidden",
    menuTypeSmall: "menu-mobile",
    backend_url: "https://backend.ayandehsazan.ir",
    // backend_url: 'http://localhost:1075',
    currentUser: {
      full_name: "",
      gender: 0,
      photo_url: "",
      slug: "",
      county_limit: null,
      province_limit: null,
      gender_limit: null,
      can_add: false,
      roles: [],
      team_category_list: [{ value: 0, text: "" }],
      province_list: [{ id: 0, name: "" }],
      county_list: [{ id: 0, name: "" }],
      city_list: [{ id: 0, name: "" }],
      gender_list: [{ value: 0, text: "" }],
    },
    grade_list: [
      { value: 0, text: "همه" },
      { value: 1, text: "متوسطه اول" },
      { value: 2, text: "متوسطه دوم" },
    ],
    archive_list: [
      { value: 0, text: "غیر فعال" },
      { value: 1, text: "فعال" },
    ],
    active_list: [
      { value: "all", text: "همه" },
      { value: "active", text: "فعال" },
      { value: "inactive", text: "غیرفعال" },
    ],
    step_list: [
      { value: 0, text: "همه" },
      { value: 7, text: "پایه هفتم" },
      { value: 8, text: "پایه هشتم" },
      { value: 9, text: "پایه نهم" },
      { value: 10, text: "پایه دهم" },
      { value: 11, text: "پایه یازدهم" },
      { value: 12, text: "پایه دوازدهم" },
      { value: "0", text: "----------", disabled: true },
      { value: 1, text: "متوسطه اول" },
      { value: 2, text: "متوسطه دوم" },
      { value: "0", text: "----------", disabled: true },
      { value: 13, text: "فارغ‌التحصیل" },
    ],
    level_list: [
      { value: "all", text: "همه" },
      { value: "local", text: "خیمه - رسا" },
      { value: "local", text: "قرارگاه منطقه‌ای غیر رسا" },
      { value: "city", text: "قرارگاه شهری" },
      { value: "province", text: "قرارگاه استانی" },
      { value: "nation", text: "قرارگاه ملی" },
    ],
    role_list: [
      { value: "all", text: "همه" },
      { value: "head", text: "مسئول انجمن" },
      { value: "cabinet", text: "عضو هیأت مرکزی" },
      { value: "member", text: "عضو انجمن" },
      { value: "0", text: "----------", disabled: true },
      { value: "platoon_local", text: "عضو قرارگاه منطقه‌ای" },
      { value: "platoon_city", text: "عضو قرارگاه شهری" },
      { value: "platoon_province", text: "عضو قرارگاه استانی" },
      { value: "platoon_nation", text: "عضو قرارگاه ملی" },
      { value: "0", text: "----------", disabled: true },
      { value: "none", text: "بدون نقش" },
    ],
    menu: {
      team_category: 0,
      group: "2",
      province: 0,
      county: 0,
      city: 0,
      gender: "all",
      grade: 0,
      active: "active",
      step: 0,
      level: "all",
      role: "all",
      trust: "True",
      q_school: "",
      q_student: "",
      q_mentor: "",
      q_platoon: "",
      q_team: "",
    },
    school_page_is_update: false,
    student_page_is_update: false,
    mentor_page_is_update: false,
    platoon_page_is_update: false,
    team_page_is_update: false,
    active_page_has_submenu: false,
    reloading: false,
    visible_years: [],
    school_major_list: [],
    organization_list: [],
    ngo_list: [],
    global_province_list: [],
    global_city_list: [],
  },

  getters: {
    Summery: (state) => state.summery,
    MenuType: (state) => state.menuType,
    MenuTypeLarge: (state) => state.menuTypeLarge,
    MenuTypeSmall: (state) => state.menuTypeSmall,
    BackendUrl: (state) => state.backend_url,
    CurrentUser: (state) => state.currentUser,
    ProvinceList: (state) => state.currentUser.province_list,
    CityList: (state) => state.currentUser.city_list,
    Menu: (state) => state.menu,
    Reloading: (state) => state.reloading,
    VisibleYears: (state) => state.visible_years,

    SchoolMajorList: (state) => state.school_major_list,
    OrganizationList: (state) => state.organization_list,
    NgoList: (state) => state.ngo_list,
    GlobalProvinceList: (state) => state.global_province_list,
    GlobalCityList: (state) => state.global_city_list,
  },

  mutations: {
    setSchoolQ(state, payload) {
      state.menu.q_school = payload;
    },
    setStudentQ(state, payload) {
      state.menu.q_student = payload;
    },
    setMentorQ(state, payload) {
      state.menu.q_mentor = payload;
    },
    setPlatoonQ(state, payload) {
      state.menu.q_platoon = payload;
    },
    setTeamQ(state, payload) {
      state.menu.q_team = payload;
    },
    setArchive(state, payload) {
      state.menu.archive = payload;
    },
    setSummery(state, payload) {
      state.summery = payload;
    },
    setMenuType(state, payload) {
      state.menuType = payload;
      if (
        !this.state.active_page_has_submenu &&
        state.menuType === "menu-default"
      )
        state.menuType = "menu-default main-hidden sub-hidden";
    },
    toggleSideMenuStatus(state) {
      if (state.menuType === "menu-default main-hidden sub-hidden") {
        state.menuType = "menu-default sub-hidden";
        state.menuTypeLarge = "menu-default sub-hidden";
      } else if (state.menuType === "menu-default sub-hidden") {
        state.menuType = "menu-default";
        state.menuTypeLarge = "menu-default";
      } else {
        state.menuType = "menu-default main-hidden sub-hidden";
        state.menuTypeLarge = "menu-default main-hidden sub-hidden";
      }
      if (
        !this.state.active_page_has_submenu &&
        state.menuType === "menu-default"
      ) {
        state.menuType = "menu-default main-hidden sub-hidden";
        state.menuTypeLarge = "menu-default main-hidden sub-hidden";
      }
    },
    toggleSideMenuForMobile(state) {
      if (state.menuType === "menu-mobile") {
        state.menuType = "menu-mobile main-show-temporary";
        state.menuTypeSmall = "menu-mobile main-show-temporary";
      } else if (state.menuType === "menu-mobile main-show-temporary") {
        state.menuType = "menu-mobile main-show-temporary sub-show-temporary";
        state.menuTypeSmall =
          "menu-mobile main-show-temporary sub-show-temporary";
      } else {
        state.menuType = "menu-mobile";
        state.menuTypeSmall = "menu-mobile";
      }
    },
    setCurrentUser(state, payload) {
      state.currentUser = payload;
    },
    setCountyList(state, payload) {
      state.currentUser.county_list = payload;
      state.currentUser.county_list.unshift({ id: 0, name: "همه" });
      state.menu.county = 0;
    },
    setCityList(state, payload) {
      state.currentUser.city_list = payload;
      state.currentUser.city_list.unshift({ id: 0, name: "همه" });
      state.menu.city = 0;
    },

    setMenuTeamCategory(state, payload) {
      state.menu.team_category = payload;
    },
    setMenuProvince(state, payload) {
      state.menu.province = payload;
    },
    setMenuCounty(state, payload) {
      state.menu.county = payload;
    },
    setMenuCity(state, payload) {
      state.menu.city = payload;
    },
    setMenuGender(state, payload) {
      state.menu.gender = payload;
    },

    setSchoolPageIsUpdate(state, payload) {
      state.school_page_is_update = payload;
    },
    setStudentPageIsUpdate(state, payload) {
      state.student_page_is_update = payload;
    },
    setMentorPageIsUpdate(state, payload) {
      state.mentor_page_is_update = payload;
    },
    setPlatoonPageIsUpdate(state, payload) {
      state.platoon_page_is_update = payload;
    },
    setTeamPageIsUpdate(state, payload) {
      state.team_page_is_update = payload;
    },
    setReloading(state, payload) {
      state.reloading = payload;
    },

    setActivePageHasSubmenu(state, payload) {
      state.active_page_has_submenu = payload;
      if (
        !this.state.active_page_has_submenu &&
        state.menuType === "menu-default"
      )
        state.menuType = "menu-default sub-hidden";
    },
    setVisibleYears(state, payload) {
      state.visible_years = payload;
    },

    setLogout(state) {
      state.currentUser = {};
      state.summery = {
        school: 0,
        student: 0,
        platoon: 0,
        adviser: 0,
        title: "",
      };
    },
    setCurrentUserPhoto(state, payload) {
      state.currentUser.photo_url = payload;
    },

    setSchoolMajorList(state, payload) {
      state.school_major_list = payload;
    },
    setOrganizationList(state, payload) {
      state.organization_list = payload;
    },
    setNgoList(state, payload) {
      state.ngo_list = payload;
    },
    setGlobalProvinceList(state, payload) {
      state.global_province_list = payload;
    },
    setGlobalCityList(state, payload) {
      state.global_city_list = payload;
    },
  },

  actions: {
    setCurrentUser({ commit }, payload) {
      commit("setCurrentUser", payload);
      commit("setMenuTeamCategory", payload.team_category_list[0].value);
      commit("setMenuProvince", payload.province_list[0].id);
      commit("setMenuCounty", payload.county_list[0].id);
      commit("setMenuCity", payload.city_list[0].id);
      commit("setMenuGender", payload.gender_list[0].value);
      axios
        .get("b/org/get-visible-years/")
        .then((res) => commit("setVisibleYears", res.data))
        .catch((err) => console.log(err.response.data));
    },
    reloadSchoolList({ commit }) {
      commit("setSchoolList", { list: "", total_count: 0 });
      commit("setReloading", true);
      axios
        .get("/b/org/school-list/0/", {
          headers: { Authorization: "token " + cookie.get("userToken") },
          params: this.state.menu,
        })
        .then((res) => {
          commit("setSchoolList", res.data);
          commit("setSchoolPageIsUpdate", true);
        })
        .catch((err) => console.error(err.response.data))
        .finally(() => commit("setReloading", false));
    },
    reloadStudentList({ commit }) {
      commit("setStudentList", { list: "", total_count: 0 });
      commit("setReloading", true);
      axios
        .get("/b/org/student-list/0/", {
          headers: { Authorization: "token " + cookie.get("userToken") },
          params: this.state.menu,
        })
        .then((res) => {
          commit("setStudentList", res.data);
          commit("setStudentPageIsUpdate", true);
        })
        .catch((err) => console.log(err.response.data))
        .finally(() => commit("setReloading", false));
    },
    reloadMentorList({ commit }) {
      commit("setMentorList", { list: "", total_count: 0 });
      commit("setReloading", true);
      axios
        .get("/b/org/mentor-list/0/", {
          headers: { Authorization: "token " + cookie.get("userToken") },
          params: this.state.menu,
        })
        .then((res) => {
          commit("setMentorList", res.data);
          commit("setMentorPageIsUpdate", true);
        })
        .catch((err) => console.log(err.response.data))
        .finally(() => commit("setReloading", false));
    },
    reloadPlatoonList({ commit }) {
      commit("setPlatoonList", { list: "", total_count: 0 });
      commit("setReloading", true);
      axios
        .get("/b/org/platoon-list/0/", {
          headers: { Authorization: "token " + cookie.get("userToken") },
          params: this.state.menu,
        })
        .then((res) => {
          commit("setPlatoonList", res.data);
          commit("setPlatoonPageIsUpdate", true);
        })
        .catch((err) => console.log(err.response.data))
        .finally(() => commit("setReloading", false));
    },
    reloadTeamList({ commit }) {
      commit("setTeamList", { list: [], total_count: 0 });
      commit("setReloading", true);
      axios
        .get("b/tm/team-list/0/", {
          headers: { Authorization: "token " + cookie.get("userToken") },
          params: this.state.menu,
        })
        .then((res) => {
          commit("setTeamList", res.data);
          commit("setTeamPageIsUpdate", true);
        })
        .catch((err) => console.log(err.response.data))
        .finally(() => commit("setReloading", false));
    },
  },
  // plugins: [createPersistedState()],
  modules: {
    school,
    student,
    mentor,
    platoon,
    user,
    team,
  },
});
